export default "__VITE_ASSET__df243cb6__"